/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

// $FlowExpectedError
import navCommunity from '../../content/community/nav.yml';

// $FlowExpectedError
import navTutorial from '../../content/tutorial/nav.yml';

const sectionListCommunity = navCommunity.map((item: Object): Object => ({
  ...item,
  directory: 'useful',
}));

console.table(sectionListCommunity)
console.table(sectionListCommunity.items)

export {
  sectionListCommunity,
  navTutorial as sectionListTutorial,
};
